// SPDX-License-Identifier: AGPL-3.0-or-later

import {KnowsHistoryButton} from '@app/features/konvo_knows/components/KnowsHistory';
import KonvoKnowsTab from '@app/features/konvo_knows/components/KonvoKnowsTab';
import CustomiseHomeSettingsTab from '@app/features/konvo_today/components/settings/CustomiseHomeSettingsTab';
import {AccessibilityTab} from '@app/features/user/components/modals/tabs/AccessibilityTab';
import AccountSecurityTab from '@app/features/user/components/modals/tabs/AccountSecurityTab';
import AdvancedSettingsTab from '@app/features/user/components/modals/tabs/AdvancedSettingsTab';
import {AppearanceTab} from '@app/features/user/components/modals/tabs/AppearanceTab';
import ApplicationsTab from '@app/features/user/components/modals/tabs/applications_tab';
import ChatSettingsTab from '@app/features/user/components/modals/tabs/ChatSettingsTab';
import ComponentGalleryTab from '@app/features/user/components/modals/tabs/component_gallery_tab';
import DesktopSettingsTab from '@app/features/user/components/modals/tabs/DesktopSettingsTab';
import EmbedDebuggerTab from '@app/features/user/components/modals/tabs/EmbedDebuggerTab';
import ExpressionPacksTab from '@app/features/user/components/modals/tabs/ExpressionPacksTab';
import KeybindsTab from '@app/features/user/components/modals/tabs/KeybindsTab';
import KonvoAssistantAutomationsTab from '@app/features/user/components/modals/tabs/KonvoAssistantAutomationsTab';
import KonvoAssistantSettingsTab from '@app/features/user/components/modals/tabs/KonvoAssistantSettingsTab';
import KonvoCalendarSettingsTab from '@app/features/user/components/modals/tabs/KonvoCalendarSettingsTab';
import KonvoMailSettingsTab from '@app/features/user/components/modals/tabs/KonvoMailSettingsTab';
import KonvoMobileRailSettingsTab from '@app/features/user/components/modals/tabs/KonvoMobileRailSettingsTab';
import KonvoRailSettingsTab from '@app/features/user/components/modals/tabs/KonvoRailSettingsTab';
import LanguageTab from '@app/features/user/components/modals/tabs/LanguageTab';
import LinkedAccountsTab from '@app/features/user/components/modals/tabs/LinkedAccountsTab';
import MyProfileTab from '@app/features/user/components/modals/tabs/MyProfileTab';
import NotificationsTab from '@app/features/user/components/modals/tabs/NotificationsTab';
import PrivacySafetyTab from '@app/features/user/components/modals/tabs/PrivacySafetyTab';
import VoiceVideoTab from '@app/features/user/components/modals/tabs/VoiceVideoTab';
import type {UserSettingsTabType} from '@app/features/user/components/settings_utils/SettingsSectionRegistry';
import type React from 'react';
import {createElement} from 'react';

const DESKTOP_TAB_COMPONENTS: Partial<Record<UserSettingsTabType, React.ComponentType<Record<string, unknown>>>> = {
	my_profile: MyProfileTab,
	account_security: AccountSecurityTab,
	privacy_safety: PrivacySafetyTab,
	authorized_apps: AccountSecurityTab,
	blocked_users: AccountSecurityTab,
	devices: AccountSecurityTab,
	linked_accounts: LinkedAccountsTab,
	appearance: AppearanceTab,
	konvo_home: CustomiseHomeSettingsTab,
	konvo_calendar: KonvoCalendarSettingsTab,
	konvo_mail: KonvoMailSettingsTab,
	konvo_assistant: KonvoAssistantSettingsTab,
	assistant_knows: KonvoKnowsTab,
	assistant_automations: KonvoAssistantAutomationsTab,
	konvo_rail: KonvoRailSettingsTab,
	mobile_rail: KonvoMobileRailSettingsTab,
	accessibility: AccessibilityTab,
	chat_settings: ChatSettingsTab,
	voice_video: VoiceVideoTab,
	keybinds: KeybindsTab,
	notifications: NotificationsTab,
	language: LanguageTab,
	desktop_settings: DesktopSettingsTab,
	advanced_settings: AdvancedSettingsTab,
	embed_debugger: EmbedDebuggerTab,
	applications: ApplicationsTab,
	component_gallery: ComponentGalleryTab,
	expression_packs: ExpressionPacksTab,
};
/** KONVO: buttons a tab puts beside its title in the desktop settings header. */
const DESKTOP_TAB_HEADER_ACTIONS: Partial<Record<UserSettingsTabType, React.ComponentType>> = {
	assistant_knows: KnowsHistoryButton,
};

export const getSettingsTabHeaderActions = (tabType: UserSettingsTabType): React.ReactNode => {
	const Actions = DESKTOP_TAB_HEADER_ACTIONS[tabType];
	return Actions ? createElement(Actions) : undefined;
};

export const getSettingsTabComponent = (
	tabType: UserSettingsTabType,
): React.ComponentType<Record<string, unknown>> | null => {
	return DESKTOP_TAB_COMPONENTS[tabType] ?? null;
};
